import React from 'react';

import { SubRoutes } from '../../routes';

import MemberListPage from './_list';
import MemberDetailPage from './_detail';
import PreorderRecordPage from './_order';
import SpecialSubAccountListPage from './specialSubAccount/_list';
import SpecialSubAccountDetailPage from './specialSubAccount/_detail';

const MainMemberPage = () => {
  return <SubRoutes name="member" />;
};

const Member = {
  MainMemberPage,
  MemberListPage,
  MemberDetailPage,
  PreorderRecordPage,
  SpecialSubAccountListPage,
  SpecialSubAccountDetailPage,
};

export default Member;
